export class Page {
  page: number;
  elements: number;
  size: number;
  sort: string;
  search: string;
  searchElements: number;
  searchPages: number;
  totalElements: number;
  totalPages: number;
  previous: string;
  next: string;
}
